import { CanvasCard } from "@circle-react-shared/CanvasCard";
import { SCREEN_SIZES } from "@circle-react-shared/ScreenSizeSelect";
import type { CanvasSizeProps } from "../../CanvasSize";
import { CanvasSize } from "../../CanvasSize";
import type { LockscreenFrameProps } from "./LockscreenFrame";
import { LockscreenFrame } from "./LockscreenFrame";

export interface LockscreenCanvasProps
  extends LockscreenFrameProps,
    CanvasSizeProps {}

export const LockscreenCanvas = ({
  screenSize = SCREEN_SIZES.DESKTOP,
  ...rest
}: LockscreenCanvasProps) => (
  <CanvasSize screenSize={screenSize}>
    <CanvasCard className="h-full">
      <LockscreenFrame {...rest} />
    </CanvasCard>
  </CanvasSize>
);
